import React, { FC } from 'react';
import './styles.scss';

export const Footer: FC = () => {
  return (
    <footer>
      <p className='footer-container'>&copy; Toshiki Hoshina. 2024.</p> 
    </footer>
  )
}